import React from 'react';
import { Redirect } from 'react-router-dom';

const Campaign = () => {
	return <Redirect to="/client/campaign/send" />
}

export default Campaign;